module.exports = __webpack_public_path__ + "92d388a6df8612b9ecaefd234cb40615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/friends.png
// module id = 1883
// module chunks = 1